"use client";

import { IButtonElement } from "@faire/web-api/indigofair/data/IButtonElement";
import { IFaireIcon } from "@faire/web-api/indigofair/data/IFaireIcon";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";

import { ComponentLoggingEventParams } from "@faire/retailer/components/SDUI/__internal__/types";
import { SDUIButtonRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Button/SDUIButtonRenderer";

export const SDUICarouselButton: React.FC<{
  button: IButtonElement;
  loggingData: ComponentLoggingEventParams;
}> = ({ button, loggingData }) => {
  const { isMobile } = useViewport();
  const buttonElement = getButtonElement(button, isMobile);

  return (
    <SDUIButtonRenderer
      buttonElement={buttonElement}
      loggingData={loggingData}
      fireLegacyOnClickEvent
    />
  );
};

// TODO: https://fairewholesale.atlassian.net/browse/FD-208064
// Proper solution to handle responsive values for mobile
// Temporarily adding this to have arrow button in place of carousel CTA on mobile
const getButtonElement = (
  ctaButton: IButtonElement,
  isMobile: boolean
): IButtonElement => {
  if (isMobile) {
    return IButtonElement.build({
      ...ctaButton,
      icon: IFaireIcon.build({
        type: IFaireIcon.Type.ARROW,
      }),
      variant: "TERTIARY",
    });
  }
  return ctaButton;
};
